<template>
  <div class="table-responsive">
    <div class="container-table">
      <table class="table table-striped- table-bordered table-hover table-checkable">
        <thead>
          <tr>
            <th nowrap class="text-center align-middle">ID Bônus</th>
            <th nowrap class="text-center align-middle">Tipo</th>
            <th nowrap class="text-center align-middle">Serviço</th>
            <th nowrap class="text-center align-middle">Quant.</th>
            <th
              nowrap
              class="text-center align-middle"
              width="100"
              title="Quantidade consumida até o momento/vencimento"
            >
              Consum.
            </th>
            <th nowrap class="text-center align-middle" width="30">Status</th>
            <th nowrap class="text-center align-middle">Início</th>
            <th nowrap class="text-center align-middle">Expiração</th>
            <th nowrap class="text-center align-middle">Produto</th>
            <th nowrap class="text-center align-middle" width="30">Justif.</th>
            <th nowrap class="text-center align-middle" width="30">Motivo</th>
            <th nowrap class="text-center align-middle" width="30">Ações</th>
          </tr>
        </thead>
        <tbody v-for="(bonus, id) in data" :key="id">
          <tr v-for="(service, id) in bonus.services" :key="id">
            <td
              class="text-center align-middle"
              v-b-tooltip.hover
              :title="bonus.user ? 'Criado por: ' + bonus.user.name : '-'"
            >
              {{ bonus.id }}
            </td>
            <td class="text-center align-middle">
              {{ bonus.bonus_type === 1 ? 'Saldo' : 'Único' }}
            </td>
            <td class="text-center align-middle">
              {{ service.service.type }}
            </td>
            <td class="text-center align-middle">
              {{ service.amount }}
            </td>
            <td class="text-center align-middle">
              {{ service.amount_used }}
            </td>
            <td class="text-center align-middle">
              {{
                bonus.status === 2
                  ? 'Utilizado'
                  : bonus.status === 1
                  ? 'Pendente'
                  : bonus.status === 3
                  ? 'Expirado'
                  : 'Cancelado'
              }}
            </td>
            <td class="text-center align-middle">{{ bonus.start_date | month }}</td>
            <td class="text-center align-middle">{{ bonus.end_date | month }}</td>
            <td class="text-center align-middle">
              {{ bonus.product ? bonus.product.name : '-' }}
            </td>
            <td class="text-center align-middle">
              <i
                class="fa fa-exclamation-circle"
                v-b-tooltip.hover
                :title="bonus.justification ? bonus.justification : '-'"
              ></i>
            </td>
            <td class="text-center align-middle">
              <i
                class="fa fa-exclamation-circle"
                v-b-tooltip.hover
                :title="bonus.reason ? bonus.reason.reason : '-'"
              ></i>
            </td>
            <td class="text-center align-middle">
              <a
                href=""
                @click.prevent.stop="confirmDel(bonus.id, service.id)"
                class="icon-circle"
                :class="{ disabled: bonus.status > 1 }"
                v-b-tooltip.hover
                title="Excluir bônus"
              >
                <i class="fas fa-trash"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { returnMessageMixin } from '@/mixins/returnMessageMixin';

import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageMixin],
  name: 'CustomerBonuses',
  components: {},
  props: {
    customerId: Number,
  },
  data() {
    return {
      data: {},
      filters: {
        id: localStorage.customerFilterId ? localStorage.customerFilterId : '',
      },
    };
  },
  methods: {
    setStorageFilters() {
      localStorage.setItem('customerFilterId', this.filters.id);
    },
    convertFilters() {
      const filters = `?page=${this.page ? this.page : 1}&id=${
        this.filters.id ? this.filters.id : ''
      }`;
      return filters;
    },
    callData() {
      this.data.current_page = 0;
      this.setStorageFilters();
      this.getDatas();
    },
    getDatas() {
      this.getCustomersPendingBonuses();
    },
    getCustomersPendingBonuses() {
      const url = `${baseApiUrl}/v1/customer/${this.customerId}/bonuses`;

      axios
        .get(url)
        .then((res) => {
          this.data = res.data;
        })
        .catch((error) => {
          this.logMessageFormFailed(error.response);
        });
    },
    confirmDel(id, serviceId) {
      this.dialog = '';
      this.$bvModal
        .msgBoxConfirm(
          'Tem certeza que deseja excluir esse bônus? Caso ele ja tenha sido utilizado alguma vez, será cancelado.',
          {
            size: 'md',
            contentClass: 'p-3',
            bodyClass: 'modal-body-fix',
            buttonSize: 'md',
            okVariant: 'danger',
            okTitle: 'Confirmar exclusão',
            cancelTitle: 'Cancelar',
            cancelVariant: 'metal',
            footerClass: 'p-4',
            hideHeaderClose: true,
            centered: true,
          }
        )
        .then((value) => {
          if (value == true) {
            this.del(id, serviceId);
          } else {
            this.$toasted.show(
              '<i class="fas fa-exclamation-triangle"></i> O bônus não foi excluído!',
              {
                theme: 'toasted-primary',
                type: 'info',
                position: 'top-right',
                duration: 5000,
              }
            );
          }
        });
    },
    del(id, serviceId) {
      const url = `${baseApiUrl}/v1/customer/bonus/delete/${id}/${serviceId}`;
      axios
        .delete(url)
        .then((res) => {
          this.logMessage(res);
          this.getDatas();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
  },
  watch: {
    amount() {
      if (this.page === 1) {
        this.callData();
      } else {
        this.page = 1;
      }
    },
  },
  mounted() {
    this.getDatas();
    window.scroll(0, 0);
  },
};
</script>
